import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=3a3271a7&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "avatar.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/avatar/avatar.vue
// module id = 101
// module chunks = 0